import React from "react";
// import SearchDropdown from "../../../app/partials/layout/SearchDropdown";
// import UserNotifications from "../../../app/partials/layout/UserNotifications";
// import MyCart from "../../../app/partials/layout/MyCart";
// import QuickActionsPanel from "../../../app/partials/layout/QuickActionsPanel";
//import QuickPanelToggler from "./QuickPanelToggle";
//import LanguageSelector from "../../../app/partials/layout/LanguageSelector";
import UserProfile from "../../../app/partials/layout/UserProfile";
import NotificationsBar from "../../../app/common/NotificiationsBar/NotificationsBar";
// import { toAbsoluteUrl } from "../../utils/utils";
// import { Chip } from '@mui/material';
// import SupervisedUserCircle from '@mui/icons-material/SupervisedUserCircle';

import HeaderMenu from "./HeaderMenu";

export default class Topbar extends React.Component {
  render() {
    const { isSuperAdmin, selectedClientDetails } = this.props;
    return (
      <div className="kt-header__topbar">

        <HeaderMenu isSuperAdmin={isSuperAdmin} selectedClientDetails={selectedClientDetails} />
        <NotificationsBar />
        <UserProfile showAvatar={false} showHi={true} showBadge={false} />
      </div>
    );
  }
}
